// extracted by mini-css-extract-plugin
module.exports = {"root":"Prompts-m__root___13JLi"};